import {mapState, mapMutations} from "vuex";

export default (fileType) => ({
  computed: {
    ...mapState({
      existingFiles: state => {
        const identificationFiles = state.identityVerification.model.identification_files || [];
        return identificationFiles.filter(file => file.type === fileType);
      },
      deletedFiles: state => {
        return state.identityVerification.model.deleted_files || [];
      }
    })
  },
  methods: {
    ...mapMutations(['identityVerificationFieldOnInput']),
    onRemoveExistingFile(file) {
      const all = (this.$store.state.identityVerification.model.identification_files || []).slice();
      const idx = all.findIndex(f => f.uuid === file.uuid || f.attachment_uuid === file.attachment_uuid || (f.name === file.name && f.size === file.size && f.type === file.type));
      if (idx !== -1) {
        all.splice(idx, 1);
        this.identityVerificationFieldOnInput({ field: 'identification_files', value: all });
        
        // Add the attachment_uuid to deleted_files array
        const deletedFiles = (this.$store.state.identityVerification.model.deleted_files || []).slice();
        const attachmentUuid = file.attachment_uuid || file.uuid;
        if (attachmentUuid && !deletedFiles.includes(attachmentUuid)) {
          deletedFiles.push(attachmentUuid);
          this.identityVerificationFieldOnInput({ field: 'deleted_files', value: deletedFiles });
        }
      }
    },
    onMarkFileForDeletion(file) {
      const deletedFiles = (this.$store.state.identityVerification.model.deleted_files || []).slice();
      const attachmentUuid = file.attachment_uuid || file.uuid;
      if (attachmentUuid && !deletedFiles.includes(attachmentUuid)) {
        deletedFiles.push(attachmentUuid);
        this.identityVerificationFieldOnInput({ field: 'deleted_files', value: deletedFiles });
      }
    },
    onRestoreFile(file) {
      const deletedFiles = (this.$store.state.identityVerification.model.deleted_files || []).slice();
      const attachmentUuid = file.attachment_uuid || file.uuid;
      const idx = deletedFiles.indexOf(attachmentUuid);
      if (idx !== -1) {
        deletedFiles.splice(idx, 1);
        this.identityVerificationFieldOnInput({ field: 'deleted_files', value: deletedFiles });
      }
    }
  }
})


